import React, {useState} from 'react'
import axios from 'axios'
import { NotificationReducer, inititalState } from './Reducer'
import { useContext, createContext, useReducer, useEffect } from 'react'
import {  ValidateAPI, getallDcList } from '../utils/Utils'
import axiosInstance,{portInUseForAPI} from '../api/axiosInstance'
import Cookies from 'js-cookie'
const Notify = createContext()

const Context = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('userData'))
  const [state, dispatch] = useReducer(NotificationReducer, inititalState)
  const [unseenList, setunseenlist] = useState({ totalCount: 0, messageCounts: [] })
 
  function getNotificationCountForBuyer(email) {
    axiosInstance
      .get(
        `/notification/notificationListByUserCount?hFtUserId=${email}`,
          ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDCOUNT',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // return alert("some thing issue ", err)
      })
  }
  function getNotificationListForBuyer(email) {
    axiosInstance
      .get(
        `/notification/notificationListByUser?hFtUserId=${email}`,  ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDLIST',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // alert("some thing issue ", err)
      })
  }
  //Notification Count
  function getNotificationcountForSupplier(supplierId) {
    axiosInstance
      .get(
        `/notification/notificationListBySupplierCount?supplierId=${supplierId}`,  ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDCOUNT',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // return alert("some thing issue ", err);
      })
  }
  function getNotificationListForBuyer(email) {
    axiosInstance
      .get(
        `/notification/notificationListByUser?hFtUserId=${email}`,  ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDLIST',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // alert("some thing issue ", err);
      })
  }
  //Notification Count
  function getNotificationcountForSupplier(supplierId) {
    axiosInstance
      .get(
        `/notification/notificationListBySupplierCount?supplierId=${supplierId}`,  ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDCOUNT',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // alert("some thing issue ", err);
      })
  }
  // Notification List For Supplier
  function getNotificationListForSupplier(supplierId) {
    axiosInstance
      .get(
        `/notification/notificationListBySupplier?supplierId=${supplierId}`,  ValidateAPI()
      )
      .then((responce) => {
        dispatch({
          type: 'ADDLIST',
          payload: responce?.data
        })
      })
      .catch((err) => {
        // alert("some thing issue ", err);
      })
  }
  // Chnage the count stat us of notification
  function changeNotificationStaus(HFTID) {
    const requestPayload={
      "notificationIdsList": HFTID
  }
    axiosInstance
      .post(
        `/notification/notificationStatus`, requestPayload, ValidateAPI()
      )
      .then((responce) => {
        if (user?.roleName === 'BUYER_ROLE') {
          getNotificationCountForBuyer(user?.email)
          getNotificationListForBuyer(user?.email)
        } else {
          getNotificationcountForSupplier(user?.supplierId)
          getNotificationListForSupplier(user?.supplierId)
        }
      })
      .catch((err) => {
        // alert("some thing issue ", err);
      })
  }
  function updateDataCount(supplierId) {
    axiosInstance
      .get(
        `/api/admin/get-counts-email-table?vendorNumber=${supplierId}`,  ValidateAPI()
      )
      .then((response) => {
        dispatch({
          type: 'UPDATECOUNT',
          payload: response?.data
        })
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
        }
      })
  }
  
  useEffect(() => {
    const fetchDcList = () => {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const supplierId = userData?.supplierId;
      const hftOracleId = userData?.hftOracleId;
      const hasDcList = !!sessionStorage.getItem('dcList');
      const hasRole = Cookies.get('role');
    
      const role = hasRole?.toLowerCase(); 
      const isVendor = role === 'vendor';
      const isBuyer = role === 'buyer';

      if (
        !hasDcList &&
        hasRole &&
        (
          (!isVendor && !isBuyer) || 
          (isVendor && supplierId) ||
          (isBuyer && hftOracleId) 
        )
      ) {
        getallDcList();
        return true; 
      }
      return false; 
    };
  
    // Try immediately
    const success = fetchDcList();
  
    //  If it failed, set an interval to check every few seconds 
    
    if (!success) {
      const interval = setInterval(() => {
        const isDone = fetchDcList();
        if (isDone) clearInterval(interval); //stops api call once it called and get success
      }, 2000); // Checks every 2 seconds
  
      // Cleanup: Stop checking if the component unmounts
      return () => clearInterval(interval);
    }
  }, []);
  
  function getUnseenMessage()  {
    const baseURL = `${process.env.REACT_APP_API_DOMAIN}:${portInUseForAPI}`
    const isVendor = user?.userGroupName === "SUPPLIER"
    const displayName = localStorage.getItem('displayName')
    const request = !isVendor
      ? axiosInstance.get(
        `${baseURL}/api/messages/unseen/count?roleType=BUYER&buyerName=${displayName}&vendorno=${user?.supplierId ?? ''}&sku=`
      )
      : axiosInstance
        .get(
          `${baseURL}/api/messages/vendorunseen/count`, {
          params: {
            email: user?.email,
            buyerName: '',
            sku: '',
            vendorId: user?.supplierId
          }
        })
      request
        .then((res) => {
          setunseenlist(res.data)
        })
        .catch((error) => {
          console.error(error)
          
        })
    }
  return (
    <Notify.Provider
      value={{
        state,
        changeNotificationStaus,
        getNotificationCountForBuyer,
        getNotificationListForBuyer,
        getNotificationcountForSupplier,
        getNotificationListForSupplier,
        updateDataCount,
        getUnseenMessage,
        unseenList
      }}
    >
      {children}
    </Notify.Provider>
  )
}

export default Context

export const CartState = () => {
  return useContext(Notify)
}
